const SmartFilterLogo = ({ id = "sfIconBlur", size = 16 }: { id?: string; size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <filter
        id={id}
        x="0"
        y="0"
        width="16"
        height="16"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feGaussianBlur stdDeviation="1.2" result="blur" />
      </filter>
    </defs>
    <mask
      id={`${id}Mask`}
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <path
        d="M5.2 0.242C5.2 0.109 5.092 0.001 4.96 0.007C3.623 0.069 2.363 0.644 1.439 1.611C0.515 2.579 0 3.865 0 5.202C0 6.54 0.515 7.826 1.439 8.793C2.363 9.76 3.623 10.335 4.96 10.397C5.092 10.403 5.2 10.295 5.2 10.162V0.242ZM15.76 5.202C15.892 5.202 16 5.095 15.994 4.962C15.934 3.667 15.393 2.442 14.477 1.525C13.749 0.798 12.823 0.303 11.814 0.102C10.805 -0.099 9.76 0.004 8.81 0.398C8.179 0.659 7.605 1.042 7.123 1.525C6.64 2.008 6.257 2.581 5.995 3.212C5.765 3.768 5.633 4.361 5.605 4.962C5.599 5.095 5.707 5.202 5.84 5.202H15.76ZM10.8 15.762C10.8 15.895 10.907 16.003 11.039 15.997C11.641 15.969 12.233 15.837 12.789 15.606C13.42 15.345 13.994 14.962 14.477 14.479C14.959 13.996 15.342 13.423 15.604 12.792C15.865 12.161 16 11.485 16 10.802C16 10.119 15.865 9.443 15.604 8.812C15.342 8.181 14.959 7.608 14.477 7.125C13.994 6.642 13.42 6.259 12.789 5.998C12.233 5.767 11.641 5.635 11.039 5.608C10.907 5.602 10.8 5.71 10.8 5.842V15.762ZM0.24 10.802C0.107 10.802 -0.001 10.91 0.005 11.042C0.065 12.337 0.606 13.563 1.523 14.479C2.005 14.962 2.579 15.345 3.21 15.606C3.84 15.868 4.517 16.002 5.2 16.002C5.882 16.002 6.559 15.868 7.19 15.606C7.82 15.345 8.394 14.962 8.877 14.479C9.359 13.996 9.742 13.423 10.004 12.792C10.234 12.236 10.366 11.644 10.394 11.042C10.4 10.91 10.292 10.802 10.16 10.802H0.24Z"
        fill="white"
      />
    </mask>
    <g mask={`url(#${id}Mask)`}>
      <rect width="16" height="16" fill="white" />
      <rect width="16" height="16" fill="#FFC700" fillOpacity="0.331" />
      <g filter={`url(#${id})`}>
        <rect x="4.3" y="6.6" width="12.2" height="9.7" fill="#FFC700" />
        <rect x="1.2" y="1.4" width="10.6" height="9.4" fill="#C41B21" />
        <rect x="9.4" y="1.3" width="8.4" height="12.2" fill="#FF33B1" />
      </g>
    </g>
  </svg>
);

export default SmartFilterLogo;
